import { ContactInputModel } from './../models/ContactInputModel';
import { RootState } from '../../../app/store';
import { createSelector, createSlice, PayloadAction } from "@reduxjs/toolkit"
import ContactStaticResourcesModel from '../models/ContactStaticResourcesModel';

interface contactInputState {
    contactInput: ContactInputModel,
    selectedContactId: string,
    ContactInputExpand: boolean,
    triggerFocusCompanyNameInput: number,
    triggerSave: number,
    triggerRefreshInput: number,
    staticResources: ContactStaticResourcesModel
}

const initialState: contactInputState = {
    contactInput: {
        id: "",
        companyName: "",
        subAcct: "",
        keywords: "",
        companyType: "",
        country: "",
        emails: "",
        interested: "",
        sizeFocus: "",
        remarks: "",
    } as ContactInputModel,
    selectedContactId: "",
    ContactInputExpand: true,
    triggerFocusCompanyNameInput: 0,
    triggerSave: 0,
    triggerRefreshInput: 0,
    staticResources: {
        companyTypes: [],
        countries: [],
        sizeFocus: [],
        interesteds: [],
        accountTypes: []
    } as ContactStaticResourcesModel
}

export const ContactInputSlice = createSlice({
    name: "ContactInput",
    initialState,
    reducers: {
        setContactInputId: (state, action: PayloadAction<string>) => {
            state.contactInput.id = action.payload;
        },
        setContactInput: (state, action: PayloadAction<ContactInputModel>) => {
            state.contactInput = action.payload;
        },
        setCompanyName: (state, action: PayloadAction<string>) => {
            state.contactInput.companyName = action.payload;
        },
        setSubAcct: (state, action: PayloadAction<string>) => {
            state.contactInput.subAcct = action.payload;
        },
        setKeywords: (state, action: PayloadAction<string>) => {
            state.contactInput.keywords = action.payload;
        },
        setCompanyType: (state, action: PayloadAction<string>) => {
            state.contactInput.companyType = action.payload;
        },
        setCountry: (state, action: PayloadAction<string>) => {
            state.contactInput.country = action.payload;
        },
        setEmails: (state, action: PayloadAction<string>) => {
            state.contactInput.emails = action.payload;
        },
        setInterested: (state, action: PayloadAction<string>) => {
            state.contactInput.interested = action.payload;
        },
        setSizeFocus: (state, action: PayloadAction<string>) => {
            state.contactInput.sizeFocus = action.payload;
        },
        setRemarks: (state, action: PayloadAction<string>) => {
            state.contactInput.remarks = action.payload;
        },
        setSelectedContactId: (state, action: PayloadAction<string>) => {
            state.selectedContactId = action.payload;
        },
        setContactInputExpand: (state, action: PayloadAction<boolean>) => {
            state.ContactInputExpand = action.payload;
        },
        setTriggerFocusCompanyNameInput: (state, action: PayloadAction<number>) => {
            state.triggerFocusCompanyNameInput = action.payload;
        },
        resetContactInput: (state) => {
            state.contactInput = initialState.contactInput;
        },
        setTriggerSave: (state, action: PayloadAction<number>) => {
            state.triggerSave = action.payload;
        },
        setTriggerRefreshInput: (state, action: PayloadAction<number>) => {
            state.triggerRefreshInput = action.payload;
        },
        setStaticResources: (state, action: PayloadAction<ContactStaticResourcesModel>) => {
            state.staticResources = action.payload;
        },
    }
});

export const contactInputSelector = createSelector(
    (state: RootState) => state.contactInput,
    (data) => data
);

export const {
    setContactInputId,
    setContactInput,
    setCompanyName,
    setSubAcct,
    setKeywords,
    setCompanyType,
    setCountry,
    setEmails,
    setInterested,
    setSizeFocus,
    setRemarks,
    setSelectedContactId,
    setContactInputExpand,
    setTriggerFocusCompanyNameInput,
    resetContactInput,
    setTriggerSave,
    setTriggerRefreshInput,
    setStaticResources
} = ContactInputSlice.actions;

export default ContactInputSlice.reducer;